// Client turn rules for the vendor's Documents tab. The set rule itself lives
// in @l2u/shared/documentsTab (the API needs it too); it is re-exported here so
// UI callers keep a single import site.
import type { SubmissionStatus } from './types.ts';
import { approvedDocReplyAllowed } from '@l2u/shared/documentRound';
import { hasPublishedRework } from '@l2u/shared/reviewTurn';

export { isDocumentsTabDocument, type DocumentsTabQuestion } from '@l2u/shared/documentsTab';

export type DocumentTurnFields = {
  status: SubmissionStatus;
  current_round_latest_author?: 'admin' | 'vendor' | null;
  resubmitted_at?: string | null;
  reviewed_at?: string | null;
};

/** The vendor owes a reply: the reviewer spoke last this round, or a rejected renewal has no published rework. */
export function documentAwaitingVendor(sub: DocumentTurnFields): boolean {
  if (sub.current_round_latest_author === 'admin') return true;
  return sub.status === 'rejected' && !hasPublishedRework(sub);
}

/** Client mirror of the API reply guard (me.ts POST comments). Non-approved branches keep today's questionnaire rule. */
export function vendorCanReply(
  sub: { status: SubmissionStatus; current_round_has_admin_comment?: boolean },
  ctx: { hasAdminComment: boolean; hasExpiredLive: boolean; inDocumentsTab: boolean },
): boolean {
  if (sub.status === 'rejected') return true;
  if (sub.status === 'pending') return ctx.hasAdminComment;
  if (sub.status === 'approved') {
    return approvedDocReplyAllowed({
      isComplianceDoc: ctx.inDocumentsTab,
      hasExpiredLive: ctx.hasExpiredLive,
      roundHasAdminMessage: sub.current_round_has_admin_comment ?? false,
    });
  }
  return false;
}
